/* eslint-disable import/prefer-default-export */
export const FINE_POLICY_PATH = {
  MAX_OVERDUE_FINE: 'maxOverdueFine',
  MAX_OVERDUE_RECALL_FINE: 'maxOverdueRecallFine',
  NAME: 'name',
  OVERDUE_FINE_INTERVAL_ID: 'overdueFine.intervalId',
  OVERDUE_FINE_QUANTITY: 'overdueFine.quantity',
  OVERDUE_RECALL_FINE_INTERVAL_ID: 'overdueRecallFine.intervalId',
  OVERDUE_RECALL_FINE_QUANTITY: 'overdueRecallFine.quantity',
};
